module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Call/Email: " + _vm._s(_vm.call_email.number))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 pull-right"
  }, [(_vm.call_email.user_is_volunteer) ? _c('input', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Create Duplicate Call/Email"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.duplicate($event)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.statusDisplay)), _c('br')])]), _vm._v(" "), (_vm.assignToVisible) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.assigned_to_id),
      expression: "call_email.assigned_to_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.call_email.user_in_group
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.call_email, "assigned_to_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateAssignedToId()
      }]
    }
  }, _vm._l((_vm.call_email.allocated_group), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.full_name) + " \n                            ")])
  }), 0)])]), _vm._v(" "), (_vm.call_email.user_in_group) ? _c('div', [_c('a', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        return _vm.updateAssignedToId('current_user')
      }
    }
  }, [_vm._v("\n                              Assign to me\n                          ")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Action \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [(_vm.statusId === 'draft' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "forwardToWildlifeProtectionBranch",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('forward_to_wildlife_protection_branch')
      }
    }
  }, [_vm._v("\n                              Forward to Wildlife Protection Branch\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'draft' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "forwardToRegions",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('forward_to_regions')
      }
    }
  }, [_vm._v("\n                              Forward to Regions\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open_followup' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.openOffence()
      }
    }
  }, [_vm._v("\n                              Offence\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open_followup' && _vm.canUserAction && this.offenceExists) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.openSanctionOutcome()
      }
    }
  }, [_vm._v("\n                              Sanction Outcome\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "allocateForFollowUp",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('allocate_for_follow_up')
      }
    }
  }, [_vm._v("\n                              Allocate for Follow Up\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "allocateForInspection",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.allocateForInspection()
      }
    }
  }, [_vm._v("\n                              Allocate for Inspection\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "allocateForLegalCase",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.allocateForLegalCase()
      }
    }
  }, [_vm._v("\n                              Allocate for Case\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.closeButtonVisibility && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "close",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('close')
      }
    }
  }, [_vm._v("\n                              Close\n                            ")])])]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills aho2"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.cTab
    }
  }, [_vm._v("Call/Email")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.rTab
    }
  }, [_vm._v("Related Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.cTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Caller",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 form-group"
  }, [_c('label', {
    staticClass: "col-sm-12"
  }, [_vm._v("Caller name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.caller),
      expression: "call_email.caller"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.caller)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "caller", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-12"
  }, [_vm._v("Caller contact information")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.caller_phone_number),
      expression: "call_email.caller_phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.caller_phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "caller_phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Anonymous call?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.anonymous_call),
      expression: "call_email.anonymous_call"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "anon_yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.call_email.anonymous_call, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "anonymous_call", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "anon_yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.anonymous_call),
      expression: "call_email.anonymous_call"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "anon_no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.call_email.anonymous_call, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "anonymous_call", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "anon_no"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusId !== 'draft'),
      expression: "statusId !=='draft'"
    }]
  }, [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "search_person_organisation",
    attrs: {
      "parentEntity": _vm.callerEntity,
      "isEditable": _vm.personSearchVisibility,
      "classNames": "form-control",
      "initialSearchType": "individual",
      "showCreateUpdate": "",
      "personOnly": ""
    },
    on: {
      "entity-selected": _vm.entitySelected
    }
  })], 1)]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Location *",
      "Index": "1"
    }
  }, [(_vm.call_email.location) ? _c('div', [_c('MapLocation', {
    key: _vm.call_email.location.id,
    attrs: {
      "isReadonly": _vm.readonlyForm
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Details",
      "Index": "2"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Date of call")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "dateOfCallPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.date_of_call),
      expression: "call_email.date_of_call"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.call_email.date_of_call)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "date_of_call", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Time of call")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "timeOfCallPicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.time_of_call),
      expression: "call_email.time_of_call"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.call_email.time_of_call)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "time_of_call", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Volunteer")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.volunteer_id),
      expression: "call_email.volunteer_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.call_email, "volunteer_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.call_email.volunteer_list), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.full_name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Use occurrence from/to")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_from_to),
      expression: "call_email.occurrence_from_to"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "radio",
      "id": "occurenceYes"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.call_email.occurrence_from_to, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "occurrence_from_to", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "occurenceYes"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_from_to),
      expression: "call_email.occurrence_from_to"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "radio",
      "id": "occurenceNo"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.call_email.occurrence_from_to, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "occurrence_from_to", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "occurenceNo"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.occurrenceDateLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    ref: "occurrenceDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_date_from),
      expression: "call_email.occurrence_date_from"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.call_email.occurrence_date_from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "occurrence_date_from", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.call_email.occurrence_from_to),
      expression: "call_email.occurrence_from_to"
    }]
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    ref: "occurrenceDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_date_to),
      expression: "call_email.occurrence_date_to"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.call_email.occurrence_date_to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "occurrence_date_to", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.occurrenceTimeLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "occurrenceTimeStartPicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_time_start),
      expression: "call_email.occurrence_time_start"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.call_email.occurrence_time_start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "occurrence_time_start", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.call_email.occurrence_from_to),
      expression: "call_email.occurrence_from_to"
    }]
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Occurrence time to")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "occurrenceTimeEndPicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_time_end),
      expression: "call_email.occurrence_time_end"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.call_email.occurrence_time_end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "occurrence_time_end", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Classification *")]), _vm._v(" "), _c('div', _vm._l((_vm.classification_types), function(option) {
    return _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.classification_id),
        expression: "call_email.classification_id"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "radio",
        "id": 'classification_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": _vm._q(_vm.call_email.classification_id, option.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.call_email, "classification_id", option.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'classification_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Call Type *")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, _vm._l((_vm.call_types), function(option) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.call_type_id),
        expression: "call_email.call_type_id"
      }],
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "radio",
        "id": 'call_type_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": _vm._q(_vm.call_email.call_type_id, option.id)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.call_email, "call_type_id", option.id)
        }, function($event) {
          return _vm.filterWildcareSpeciesType($event, option.all_wildcare_species)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'call_type_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Wildcare Species Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.wildcare_species_type_id),
      expression: "call_email.wildcare_species_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.call_email, "wildcare_species_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.filterWildcareSpeciesSubType()
      }]
    }
  }, _vm._l((_vm.filter_wildcare_species_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.display) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Wildcare Species Sub Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.wildcare_species_sub_type_id),
      expression: "call_email.wildcare_species_sub_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.speciesSubTypeDisabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.call_email, "wildcare_species_sub_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.filter_wildcare_species_sub_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.display) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', _vm._l((_vm.age_choices), function(option) {
    return _c('div', {
      staticClass: "col-sm-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.age),
        expression: "call_email.age"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox",
        "id": 'age_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": Array.isArray(_vm.call_email.age) ? _vm._i(_vm.call_email.age, option.id) > -1 : (_vm.call_email.age)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.call_email.age,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.call_email, "age", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.call_email, "age", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.call_email, "age", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'age_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Dead")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.dead),
      expression: "call_email.dead"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "deadYes",
      "type": "radio",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.call_email.dead, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "dead", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "deadYes"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.dead),
      expression: "call_email.dead"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "deadNo",
      "type": "radio",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.call_email.dead, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "dead", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "deadNo"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Euthanise")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.euthanise),
      expression: "call_email.euthanise"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "euthaniseYes",
      "type": "radio",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.call_email.euthanise, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "euthanise", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "euthaniseYes"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.euthanise),
      expression: "call_email.euthanise"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "euthaniseNo",
      "type": "radio",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.call_email.euthanise, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "euthanise", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "euthaniseNo"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Female / Male")]), _vm._v(" "), _c('div', _vm._l((_vm.gender_choices), function(option) {
    return _c('div', {
      staticClass: "col-sm-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.gender),
        expression: "call_email.gender"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox",
        "id": 'gender_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": Array.isArray(_vm.call_email.gender) ? _vm._i(_vm.call_email.gender, option.id) > -1 : (_vm.call_email.gender)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.call_email.gender,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.call_email, "gender", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.call_email, "gender", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.call_email, "gender", $$c)
          }
        }, _vm.checkFemalePinkyJoey]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'gender_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), (_vm.isFemalePinkyJoey) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Pinky / Joey")]), _vm._v(" "), _c('div', _vm._l((_vm.baby_kangaroo_choices), function(option) {
    return _c('div', {
      staticClass: "col-sm-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.baby_kangaroo),
        expression: "call_email.baby_kangaroo"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox",
        "id": 'babyKangaroo' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": Array.isArray(_vm.call_email.baby_kangaroo) ? _vm._i(_vm.call_email.baby_kangaroo, option.id) > -1 : (_vm.call_email.baby_kangaroo)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.call_email.baby_kangaroo,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.call_email, "baby_kangaroo", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.call_email, "baby_kangaroo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.call_email, "baby_kangaroo", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'babyKangaroo' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Number of Animals")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.number_of_animals),
      expression: "call_email.number_of_animals"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.number_of_animals)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "number_of_animals", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Brief nature of call *")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.brief_nature_of_call),
      expression: "call_email.brief_nature_of_call"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.brief_nature_of_call)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "brief_nature_of_call", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Entangled")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8",
    staticStyle: {
      "padding": "0px"
    }
  }, _vm._l((_vm.entangled_choices), function(option) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.entangled),
        expression: "call_email.entangled"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox",
        "id": 'entangled_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": Array.isArray(_vm.call_email.entangled) ? _vm._i(_vm.call_email.entangled, option.id) > -1 : (_vm.call_email.entangled)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.call_email.entangled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.call_email, "entangled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.call_email, "entangled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.call_email, "entangled", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'entangled_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), (_vm.isEntangledOther) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Entangled Other")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.entangled_other),
      expression: "call_email.entangled_other"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.entangled_other)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "entangled_other", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.current_schema), function(item, index) {
    return (_vm.rendererVisibility) ? _c('div', [_c('compliance-renderer-block', {
      key: ("compliance_renderer_block_" + index),
      attrs: {
        "component": item,
        "readonlyForm": _vm.readonlyForm
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), ((_vm.call_email.referrer && _vm.call_email.referrer.length > 0) || _vm.call_email.advice_details) ? _c('FormSection', {
    attrs: {
      "formCollapse": true,
      "label": "Outcome",
      "Index": "3"
    }
  }, [(_vm.call_email.referrer && _vm.call_email.referrer.length > 0) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Referred To")]), _vm._v(" "), _c('select', {
    ref: "referrerList",
    staticClass: "form-control input-sm",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "multiple": "multiple"
    }
  }, _vm._l((_vm.call_email.referrer), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                " + _vm._s(option.name) + " \n                              ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.call_email.advice_details) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Advice details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.advice_details),
      expression: "call_email.advice_details"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": true,
      "rows": "5"
    },
    domProps: {
      "value": (_vm.call_email.advice_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "advice_details", $event.target.value)
      }
    }
  })])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.rTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": !_vm.canUserAction
    }
  })], 1) : _vm._e()])])])], 1)])])])]), _vm._v(" "), (_vm.call_email.can_user_action) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('exit')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('noexit')
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.workflow_type) ? _c('div', [_c('CallWorkflow', {
    key: _vm.workflowBindId,
    ref: "add_workflow",
    attrs: {
      "workflow_type": _vm.workflow_type
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Offence', {
    key: _vm.offenceBindId,
    ref: "offence",
    attrs: {
      "region_id": _vm.call_email.region_id,
      "district_id": _vm.call_email.district_id,
      "allocated_group_id": _vm.call_email.allocated_group_id
    }
  }), _vm._v(" "), (_vm.sanctionOutcomeInitialised) ? _c('div', [_c('SanctionOutcome', {
    ref: "sanction_outcome"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.inspectionInitialised) ? _c('div', [_c('Inspection', {
    ref: "inspection"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.legalCaseInitialised) ? _c('div', [_c('CreateLegalCaseModal', {
    ref: "legal_case"
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Currently assigned to")]), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31aeca4b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/call_email/call_email.vue
// module id = 950
// module chunks = 0